import {h} from 'preact';
import {cxMenu} from '../../styles';
import Menu from '../';
import isEmptyOrNil from '@util/fn/isEmptyOrNil';
import {mapRootUrl} from '@util/URLUtils';

const ItemGroup = ( {secondaryTitle, title, url, children} ) =>
    <ul className={`nav-group-primary--mobile ${ cxMenu.list }`}>
        <Menu.groupLabel>{secondaryTitle || title}</Menu.groupLabel>
        {
            children
                .map( mapRootUrl( {url} ) )
                .map( child => Menu[isEmptyOrNil( child.children ) ? 'itemLeaf' : 'itemNode']( child ) )
        }
    </ul>;

export default ItemGroup;